var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.87,
    clipPath: "url(#clip0_1178_11582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.48999 15.27C0.48999 15.4636 0.566905 15.6493 0.703815 15.7862C0.840724 15.9231 1.02641 16 1.22003 16H14.3608C14.5544 16 14.7401 15.9231 14.877 15.7862C15.0139 15.6493 15.0909 15.4636 15.0909 15.27V13.8099H0.48999V15.27ZM14.2619 8.65214C13.1132 9.22668 9.11508 11.0832 8.96908 11.1522C8.56226 11.3425 8.11943 11.4435 7.67033 11.4486C7.21562 11.4561 6.76887 11.3287 6.38657 11.0824C6.00428 10.8361 5.7036 10.4819 5.52254 10.0648C5.32641 9.59052 5.27579 9.06864 5.37712 8.56553C5.47846 8.06243 5.72717 7.60084 6.09161 7.2395H1.22003C1.02641 7.2395 0.840724 7.31642 0.703815 7.45333C0.566905 7.59024 0.48999 7.77593 0.48999 7.96954V12.3498H15.0909V8.06555C14.8402 8.29507 14.5617 8.49214 14.2619 8.65214Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.15039 5.77939C5.15039 5.77939 5.27997 5.18331 5.53804 4.24082C5.71435 3.59802 7.97821 0.780051 8.84514 0.490954C9.70075 0.205507 14.4979 0 14.4979 0L16.5142 3.66226C16.5142 3.66226 14.7505 6.77407 13.6072 7.34569C12.464 7.91732 8.32973 9.83733 8.32973 9.83733C8.32973 9.83733 7.25328 10.3582 6.8503 9.46391C6.54368 8.78424 7.23685 8.1575 7.23685 8.1575C7.23685 8.1575 8.81594 7.06244 9.42698 6.5817C9.87085 6.23165 10.3395 5.53519 9.71462 4.90954C9.0897 4.28389 8.45092 4.90333 8.11911 5.19097C7.78731 5.47861 7.46171 5.77939 7.46171 5.77939H5.15039Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1178_11582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardHand);
export default __webpack_public_path__ + "static/media/CardHand.6c288f3d93ccc676dc79c77bc1f2653e.svg";
export { ForwardRef as ReactComponent };